import React, { useState } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import localization from 'assets/localization/localization';
import Regex from 'services/utils/regex/Regex';

const FeedbackFilter = ({
  applyFilter,
  siteTypes = [],
  agenda= [],
  assignedAreas = [],
  reportees = [],
  siteStatus = []
}) => {
  const filterInputs = {
    site_no: '',
    client_name: '',
    // site_type: '',
    // area_id: '',
    // reportee: '',
    // status_id: '',
    agenda:''
  };

  const [filterFieldsData, setFilterFieldsData] = useState(filterInputs);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label={localization.baName}
        value={filterFieldsData.ba_name}
        regex={Regex.number.test(filterFieldsData.ba_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, ba_name: val })
        }
      />
      <ConstantInput
        label={localization.businessName}
        value={filterFieldsData.client_name}
        regex={Regex.text.test(filterFieldsData.client_name)}
        type="text"
        handleChange={(val) =>
          setFilterFieldsData({ ...filterFieldsData, client_name: val })
        }
      />
      
      
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            applyFilter(filterInputs);
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default FeedbackFilter;
